import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=dece2136&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=dece2136&prod&lang=scss&scoped=true&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=dece2136&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dece2136",
  null
  
)

export default component.exports